import React, { ReactElement, ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import type { RootState } from "../../services/store";
import Loader from "../loader/loader";

type ProtectedRouteProps = {
  children: ReactNode;
  requireProfile?: boolean;
  requireCompleteProfile?: boolean;
  requireActiveProfile?: boolean;
};

export const ProtectedRouteElement = ({
  children,
  requireProfile = false,
  requireCompleteProfile = false,
  requireActiveProfile = false,
}: ProtectedRouteProps): ReactElement | null => {
  const location = useLocation();

  const {
    isAuthLoading,
    isAuthChecked,
    userTelegram,
    profile,
  } = useSelector((state: RootState) => state.user);

  /** ⏳ Пока идёт проверка авторизации */
  if (isAuthLoading) {
    return <Loader />;
  }



  /** 🔐 Авторизация завершена, но пользователя нет */
  if (isAuthChecked && !userTelegram) {
    return (
      <Navigate
        to="/not-access"
        replace
        state={{ from: location }}
      />
    );
  }

  /** 👤 Требуется профиль */
  if (requireProfile && !profile) {
    return (
      <Navigate
        to="/home"
        replace
        state={{ from: location }}
      />
    );
  }

  /** 🕒 Профиль должен пройти модерацию */
  if (requireActiveProfile && profile?.status !== 'ACTIVE') {
    return (
      <Navigate
        to="/profile-moderation"
        replace
        state={{ from: location }}
      />
    );
  }

  /** ✅ Требуется заполненный профиль */
  if (requireCompleteProfile && profile) {
    if (!profile.interests?.length) {
      return (
        <Navigate
          to="/profile-interests"
          replace
          state={{ from: location }}
        />
      );
    }

    if (!profile.photos?.length) {
      return (
        <Navigate
          to="/profile-photos"
          replace
          state={{ from: location }}
        />
      );
    }
  }

  return <>{children}</>;
};
